export const patentReminderFields = [
    {name:'Earliest Priority', value:'earliestPriorityDate'},
    {name:'Filing', value:'filingDate'},
    {name:'Planned Filing', value:'plannedFilingDate'},
    {name:'Official Filing', value:'officialFilingDate'},
    {name:'National Entry', value:'nationalEntryDate'},
    {name:'Publication', value:'publicationDate'},
    {name:'Estimated First Office Action', value:'estimatedFirstOfficeActionDate'},
    {name:'Official Office Action', value:'officialOfficeActionDate'},
    {name:'Allowance', value:'allowanceDate'},
    {name:'Examiner Interview', value:'examinerInterviewDate'},
    {name:'RCE Filed', value:'RCEFiledDate'},
    {name:'Issue Fee Payment', value:'issueFeePaymentDate'},
    {name:'Issue', value:'issueDate'},
    {name:'Maintenance Fee Due', value:'maintenanceFeeDueDate'},
    {name:'Expiration', value:'expirationDate'},
    {name:'Abandoned', value:'abandonedDate'},
]

export const trademarkReminderFields = [
    {name:'Filing', value:'filingDate'},
    {name:'Priority', value:'priorityDate'},
    {name:'Registration', value:'registrationDate'},
    {name:'National Entry', value:'nationalEntryDate'},
    {name:'Next Action Due', value:'nextActionDueDate'},
]

export const leadReminderFields = [
    {name:'Created', value:'createdAt'},
    {name:'Last Updated', value:'updatedAt'},
    // {name:'Submitted', value:'submissionDate'},
    // {name:'Approved', value:'approvalDate'},
    // {name:'Analyst Deadline', value:'dueDate'},
    // {name:'Client Deadline', value:'clientDeadline'},
]